"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_student_purchased_time_html_1 = __importDefault(require("./admin-student-purchased-time.html"));
var admin_student_purchased_time_controller_1 = __importDefault(require("./admin-student-purchased-time.controller"));
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes.filter(function (type) {
            return type.status === "Active";
        });
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes.filter(function (type) {
            return type.status === "Active";
        });
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.purchasedtime", {
        url: "/purchased-time",
        controller: admin_student_purchased_time_controller_1.default,
        controllerAs: "vm",
        template: admin_student_purchased_time_html_1.default,
        resolve: {
            sessiontypes: getSessionTypes,
            coursetypes: getCourseTypes,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.purchasedtime", [])
    .config(config)
    .controller("AdminStudentPurchasedTimeController", admin_student_purchased_time_controller_1.default);
